<h2 mat-dialog-title class="dialog-title">{{ data.name }}</h2>

<div mat-dialog-content class="dialog-content">
  <!-- Quantity (custom stepper layout; input stays editable) -->
  <div class="qty-row">
    <label class="qty-label">Quantity</label>

    <div class="qty-group" role="group" aria-label="Quantity stepper">
      <button
        mat-mini-fab
        type="button"
        class="qty-btn"
        (click)="decreaseQuantity()"
        [disabled]="data.quantity <= 0"
        aria-label="Decrease quantity"
        aria-controls="qtyInput"
        tabindex="0"
      >
        <span class="btn-icon">−</span>
      </button>

      <!-- Editable input (typing allowed) -->
      <input
        id="qtyInput"
        class="qty-input"
        type="number"
        min="0"
        [ngModel]="data.quantity"
        (ngModelChange)="data.quantity = $event"
        inputmode="numeric"
        aria-label="Quantity"
      />

      <button
        mat-mini-fab
        type="button"
        class="qty-btn"
        (click)="increaseQuantity()"
        aria-label="Increase quantity"
        aria-controls="qtyInput"
        tabindex="0"
      >
        <span class="btn-icon">+</span>
      </button>
    </div>

    <small class="qty-hint">Tap +/− or type a number</small>
  </div>

  <!-- Price -->
  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Price</mat-label>
    <input matInput type="number" min="0" step="0.01" inputmode="decimal" [(ngModel)]="data.price" />
  </mat-form-field>

  <!-- Reason -->
  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Reason</mat-label>
    <mat-select [(ngModel)]="data.reason">
      <mat-option *ngFor="let reason of reasons" [value]="reason">{{ reason }}</mat-option>
    </mat-select>
  </mat-form-field>
</div>

<!-- remove align="end" so our flex rules can take over -->
<div mat-dialog-actions class="dialog-actions dialog-actions--even">
  <button mat-stroked-button color="warn" class="action-btn" (click)="deleteItem()">Delete</button>
  <button mat-stroked-button class="action-btn" (click)="dialogRef.close()">Cancel</button>
  <button mat-flat-button color="primary" class="action-btn" (click)="save()">Save</button>
</div>

